import { render, staticRenderFns } from "./GridPanel.vue?vue&type=template&id=283ad2fb&"
import script from "./GridPanel.vue?vue&type=script&lang=js&"
export * from "./GridPanel.vue?vue&type=script&lang=js&"
import style0 from "./GridPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports